import logo from '../assets/logo.png';

export default function ApexLogo({ size = 120, glow = true }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        flexShrink: 0,
        boxShadow: glow
          ? '0 0 40px 12px rgba(59,130,246,0.6), 0 0 80px 24px rgba(6,182,212,0.3)'
          : 'none',
      }}
    >
      <img
        src={logo}
        alt="APEX"
        style={{
          width: '120%',
          height: '120%',
          objectFit: 'cover',
          marginLeft: '-10%',
          marginTop: '-10%',
        }}
      />
    </div>
  );
}
